<template>
  <div>
    <common-header>
      <template #title>
        <p class="title">Folders</p>
      </template>
      <template #btn>
        <el-col style="width: 65px">
          <el-button
            class="btn btn-default btn-outline-pink"
            @click.native="asc = !asc"
          >
            <i :class="asc ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"></i>
          </el-button>
        </el-col>
      </template>
    </common-header>
    <el-row :gutter="20">
      <el-col
        :span="6"
        v-for="(f, index) in sortFolder"
        :key="index"
        style="margin-bottom: 10px; min-width: 300px; max-height: 60px"
        @contextmenu.native="
          showContextMenu({ type: CONSTANT.MENU_TYPE.CREATIVE_FOLDER, row: f })
        "
      >
        <el-card
          shadow="hover"
          @click.native="$router.push({ path: `/folder/${f._id}` })"
          style="white-space: nowrap"
          :body-style="{ cursor: 'pointer' }"
        >
          <i class="fas fa-folder gray"></i>
          <span>{{ f.name }}</span>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import CommonHeader from "@/components/base/header";
export default {
  data() {
    return {
      asc: true,
    };
  },
  components: {
    CommonHeader,
  },
  computed: {
    ...mapState({
      folders: (state) => state.creativeFolder.folders,
    }),
    orders() {
      return this.asc ? "asc" : "desc";
    },
    sortFolder() {
      return _.orderBy(this.folders, "name", this.orders);
    },
  },
  methods: {
    ...mapActions({
      showContextMenu: "showContextMenu",
    }),
  },
};
</script>

<style></style>
